import { FormlyFieldConfig } from '@ngx-formly/core';

export type AccountInfoFormModel = {
  username: string;
  firstName: string;
  lastName: string;
};

export const AccountInfoForm: () => FormlyFieldConfig[] = () => {
  return [
    {
      fieldGroupClassName: 'row mb-2',
      fieldGroup: [
        {
          className: 'col-6',
          key: 'firstName',
          type: 'input',
          props: { label: 'First Name', required: true, cols: 6 },
        },
        {
          className: 'col-6',
          key: 'lastName',
          type: 'input',
          props: { label: 'Last Name', required: true, cols: 6 },
        },
      ],
    },
  ];
};
